import { addHours, format } from "date-fns";

export type DateRange = {
  from: Date;
  to: Date;
};

export function isDateAfterHours(date: Date | string, hours: number): boolean {
  const result = new Date(date);
  let d = addHours(new Date(), -hours);
  return result > d;
}

export function dateInRange(
  date: Date | string,
  start: Date,
  end: Date,
): boolean {
  const d = new Date(date);
  return d >= start && d <= end;
}

export function dateToApiDate(date: Date, encode: boolean = false) {
  let dt = format(date, "yyyy-MM-dd HH:mm:ss");

  return encode ? encodeURIComponent(dt) : dt;
}
